/**
 * @param {string || number} phone
 * @returns {Boolean}
 */
export function validPhone(phone) {
  const reg = /(^1\d{10}$)|(^[0-9]\d{7}$)/
  return reg.test(phone)
}

/**
 * @param {string || number} num
 * @returns {Boolean}
 */
export function validInt(num) {
  const reg = /(^[0-9]*[1-9][0-9]*$)/
  return reg.test(num)
}

/**
 * @param {string || number} float_number
 * @returns {Boolean}
 */
export function validFloatNumber(float_number, len = 8) {
  const reg = /^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/
  if (float_number.indexOf('.') != -1) {
    len += 3
  }
  if (float_number.length > len) {
    return false
  }
  return reg.test(float_number)
}

/**
 * @param {string} 指定用户
 * @returns {Boolean}
 */
export function validUserPhone(str) {
  const reg = /^([0-9]+,)*[0-9]+$/
  return reg.test(str)
}
